import { useTranslation } from "react-i18next";
import cn from "classnames";
import { Smallcaps } from "iconsax-react";
import { useAccessibilityControls } from "../hooks";
import type { ZoomLevel } from "../types";

const ZOOM_LEVELS: ZoomLevel[] = [1.0, 1.1, 1.25];
const ZOOM_LABELS: Record<ZoomLevel, string> = { 1.0: "A", 1.1: "A+", 1.25: "A++" };

export default function FontSizeRow() {
  const { t } = useTranslation("Sidebar");
  const { zoom, setZoomLevel } = useAccessibilityControls();

  return (
    <div className="flex items-center gap-2 my-1 radius-sm py-1">
      <div className="flex items-center justify-center">
        <Smallcaps size={18} color="currentColor" className="shrink-0 content-base-primary" />
      </div>
      <div className="flex items-center justify-between flex-1">
        <span className="text-label-sm content-base-primary whitespace-nowrap">{t("fontSize")}</span>
        <div className="flex items-center gap-1 surface-secondary-fill radius-sm">
          {ZOOM_LEVELS.map((zoomLevel) => {
            const isSelected = zoom === zoomLevel;
            return (
              <button
                key={zoomLevel}
                type="button"
                aria-pressed={isSelected}
                onClick={() => setZoomLevel(zoomLevel)}
                className={cn(
                  "w-8 h-7 flex items-center justify-center radius-sm transition-all cursor-pointer",
                  isSelected ? "surface-brand-fill" : "hover:surface-base-fill",
                )}>
                <span className={cn("text-label-xs", isSelected ? "content-static-white" : "content-base-primary")}>
                  {ZOOM_LABELS[zoomLevel]}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
